import React from "react";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiSelect from "components/VuiSelect";
import { ALL_REGIONS_OPTION, SelectOption } from "../types/SelectTypes";

interface RegionSelectorProps {
  regionOptions: SelectOption[];
  onRegionChange: (option: any) => void;
}

const RegionSelector: React.FC<RegionSelectorProps> = ({
  regionOptions,
  onRegionChange
}) => {
  return (
    <VuiBox display="flex" alignItems="center" justifyContent="flex-end">
      <VuiTypography variant="button" color="text" mr={1}>
        Filter by Region:
      </VuiTypography>
      <div style={{ width: '330px' }}>
        <VuiSelect
          //@ts-ignore
          defaultValue={ALL_REGIONS_OPTION}
          onChange={onRegionChange}
          options={regionOptions}
        />
      </div>
    </VuiBox>
  );
};

export default RegionSelector;
